import type * as Types from '../../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type CookiePreferenceFragment = {
  __typename?: 'CookiePreference';
  createdAt?: any | null;
  functional?: boolean | null;
  id: string;
  necessary?: boolean | null;
  statistic?: boolean | null;
  advertising?: boolean | null;
  updatedAt?: any | null;
  uuid: string;
};

export type CookiePreferenceQueryVariables = Types.Exact<{
  uuid: Types.Scalars['String']['input'];
}>;

export type CookiePreferenceQuery = {
  __typename?: 'Query';
  cookiePreferenceByUuid?: {
    __typename?: 'CookiePreference';
    createdAt?: any | null;
    functional?: boolean | null;
    id: string;
    necessary?: boolean | null;
    statistic?: boolean | null;
    advertising?: boolean | null;
    updatedAt?: any | null;
    uuid: string;
  } | null;
};

export const CookiePreferenceFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CookiePreference' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CookiePreference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'functional' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'necessary' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'statistic' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'advertising' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uuid' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CookiePreferenceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cookiePreference' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cookiePreferenceByUuid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uuid' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'uuid' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CookiePreference' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CookiePreference' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CookiePreference' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'functional' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'necessary' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'statistic' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'advertising' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uuid' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class CookiePreferenceGQL extends Apollo.Query<CookiePreferenceQuery, CookiePreferenceQueryVariables> {
  document = CookiePreferenceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
